import React/*, {useState}*/ from 'react';
import EventEmitter from '../utils/emmiter';
import {useracc, postApi} from '../utils/functions';
import {UserContext} from '../utils/usercontext';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';

import styled from 'styled-components';

import './css/overlay.css';

import Canvas from './canvas.js';

/*import GiphyTenor from './giphytenor';
import Messaging from './messaging';
import Emojis from './emojis';
import Opening from './opening';
import Handover from './handover';
*/
/*
	
	other ideas for animation effects

*/

class UltrastreamOverlay extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
		//console.log(this.props);
    this.state = {

			//---- Current Channel
			service: {
				mode: 0,
				key: this.props.id,
				name: '',
				avatar: '',
			},
			//servicekey: this.props.id?this.props.id:'',
			//servicename: '',
			//servicelogo: '',

			//---- Active templates in OBS
			settings: {
				
				EmojisEmotes: null, //[ true, Math.floor(Date.now()/1000), 0 ],
				GiphyTenor: null, //[ true, Math.floor(Date.now()/1000), 0 ],
				Messaging: null, //[ true, Math.floor(Date.now()/1000), 0 ],
				Introduction: null,
				Handover: null,
				Globe: null,
				Welcome: null,
				Clock: null,
				TrackID: null, //[ false, 0, 0 ],
				Alerts: null, //[ false, Math.floor(Date.now()/1000), 0 ]
				
			},

			//---- Schedule
			schedule: [],

			//schedule: {},
			ListenerOverlay: null,
			ListenerTrackID: null,

    };

		this.obsEngine = this.obsEngine.bind(this);
		this.obsStatus = this.obsStatus.bind(this);
		this.register = this.register.bind(this);
    
  };

  async componentDidMount() {
		
		let value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		

		/*---- So here and what we looking to do is to split to allow on standard browsers
		 0 - Not started
		 1 - Invalid Channel
		 2 - No OBS Access
		 3 - Test Mode
		 4 - Started
		 5 - Live
		*/

		//console.log(process.env.REACT_APP_HOST);

		//---- Require access to worker servers
		if( process.env.REACT_APP_API === 'https://api.ultrastream.io' ) {
			//console.log("fetching worker!");
			const params1 = new URLSearchParams();
			params1.append('servicekey', this.state.service.key);
			const y = await postApi('/v3/template/access', params1);
			//console.log(y.data, this.state.service.key);
			if( y.status === 200 ) {
				for( let i in y.data ) {
					value = this.context;
					let z = await value.setWorker( y.data[i].service );
					
					//console.log(value.workers);
					EventEmitter.emit('/client', z);
					//console.log(y.data[i].service, Object.values(z)[0]);

					const params2 = new URLSearchParams();
					params2.append('servicekey', this.state.service.key);
					params2.append('service', y.data[i].service);
					await postApi(`${Object.values(z)[0]}/v3/template/index`, params2);

				}
			}
		}

		//---- Service channel
		const params = new URLSearchParams();
		params.append('servicekey', this.state.service.key);
		const x = await postApi(process.env.REACT_APP_API === 'https://api.ultrastream.io'?'/v3/template/master':'/api/v2/template/master', params);
		//console.log(x.data); // ????
		
		if( x.status === 200 ) {
			let service = this.state.service;
			service.name = x.data.name;
			service.avatar = x.data.avatar;
			this.setState({service, schedule: x.data.schedule?x.data.schedule:[]});
			//this.setState({servicename: x.data.servicename, servicelogo: x.data.servicelogo});
		} else {
			let service = this.state.service;
			service.mode = 1;
			this.setState({service});
		}
		

		//---- Overlay settings
		const ListenerOverlay = EventEmitter.addListener('/template/settings', async data => {
			//console.log(data);
			let settings = this.state.settings;
			if( data.servicekey === this.state.service.key ) {
				for( let i in settings ) {
					if(settings[i] === null && data.template[i] !== null ) {
						settings[i] = data.template[i];
					}
				}
				this.setState({settings: {}}, ()=>{
					this.setState({settings});
				});
			}
		}); this.setState({ListenerOverlay});


		//---- TrackID software
		const ListenerTrackID = EventEmitter.addListener('/template/trackid', async data => {
			let settings = this.state.settings;
			if( settings.TrackID === null || settings.TrackID === false ) {
				settings.TrackID = data.data;
				this.setState({settings});
			}
		}); this.setState({ListenerTrackID});


		//---- OBS Access
		const engine = await this.obsEngine();
		const status = await this.obsStatus();

		/*let y = this.state.service;
		y.mode = 5;
		this.setState({service: y});
		return;*/

		if( engine === 0 ) {
			let service = this.state.service;
			service.mode = 2;
			this.setState({service});
			return;
		} else if ( engine === 1 ) {
			if( status ) {
				let service = this.state.service;
				service.mode = 4;
				this.setState({service}, ()=>this.register());
			} else {
				let service = this.state.service;
				service.mode = process.env.NODE_ENV==="development"?4:5;
				this.setState({service}, ()=>this.register());
				//---- Start streaming eventListener
				window.addEventListener('obsStreamingStarting', (event) => {
					//console.log(event);
					let service = this.state.service;
					if( service.mode === 5 ) {
						service.mode = 4;
						this.setState({service});
					}
				});
			}
			setTimeout(()=>{if( this.state.service.mode===5 ) {
				let service = this.state.service;
				service.mode = 4;
				this.setState({service});
			}},15000);
			setTimeout(()=>{
				this.register();
			}, 300000);
		} else {
			let service = this.state.service;
			service.mode = engine;
			this.setState({service}, ()=>this.register());
		}
		setTimeout(()=>{this.register()}, 300000);
	}

	
	componentWillUnmount() {
		if( this.state.ListenerOverlay) this.state.ListenerOverlay.remove();
		if( this.state.ListenerTrackID) this.state.ListenerTrackID.remove();
	}


	//---- OBS page access
	async obsEngine() {
		return new Promise((resolve, reject) => {
			try {
				window.obsstudio.getControlLevel((engine) => {
					//this.setState({engine});
					resolve(engine===0?0:1);
				});
			} catch(error) { resolve(3) };
		});
	}

	//---- OBS streaming
	async obsStatus() {
		return new Promise((resolve, reject) => {
			try {
				window.obsstudio.getStatus((status) => {
					resolve(status.streaming);
				});
			} catch(error) { resolve(false) };
		});
	}

	//---- Register every 5 minutes
	register() {
		EventEmitter.emit('/template/register', {key: this.state.service.key, mode: this.state.service.mode>=4?1:0});
	}

	render() {
		//console.log(this.state.valid, this.state.opening);
		const schedule = this.state.schedule.map((e,i) => {
			return (
				<div key={i}>
					<div className="overlay-flex">
						<div>
							<img src={`https://cloud.ultrastream.io/images/${e.t_avatar}`} width={64} height={64} style={{borderRadius: '50%'}} />
						</div>
						<div className="overlay-text" style={{paddingTop: e.title?0:14}}>
							{e.t_title}
							{e.title&&
								<><br />{e.title}</>
							}
						</div>
						<div className="overlay-text" style={{marginLeft: 100, paddingTop: 14}}>
							{moment(e.start).format("h:mm A")} - {moment(e.end).format("h:mm A")}
						</div>
					</div>
				</div>
			)
		});
		const _date = Math.floor(Date.now()/1000) - 60*20;
		const settings = Object.keys(this.state.settings).map((e,i) => {
			return (
				<React.Fragment key={i}>
					{this.state.settings[e] !== null &&
						<div className="overlay-panel-overlay">
							<div className="overlay-panel-overlay-template">
								{(e==='TrackID' && this.state.settings.TrackID!==false)?this.state.settings[e]:e}
								<div className="overlay-panel-overlay-check">
									<div className="overlay-panel-overlay-checked">
										{this.state.settings[e] !== false &&<>&#10004;</>}
									</div>
								</div>
							</div>
						</div>
					}
				</React.Fragment>
			)
		});
		return (
			<>
				{this.state.service.mode === 1 &&
					<>
						<div className="overlay">
							<div className="overlay-background">
							</div>
							<div className="overlay-welcome1">
								Login Failed
							</div>
							<div className="overlay-welcome3">
								Please check the URL and try again.
							</div>
						</div>
						{this.state.servicelogo &&
							<div className="overlay-logo">
								<img src={this.state.service.logo} alt="Logo" width="100%" height="100%" />
							</div>
						}
					</>
				}
				{this.state.service.mode === 2 &&
					<>
						<div className="overlay">
							<div className="overlay-background"></div>
							
							<div className="overlay-version">
								Please set "Page permissions" to a minimum of "Read access to OBS status information"
							</div>
							
						</div>
						<div className="overlay-logo">
							<img src={this.state.service.logo} alt="Logo" width="100%" height="100%" />
						</div>
					</>
				}
				{this.state.service.mode >= 3 &&
					<>
						{/*}
						<GiphyTenor channel={this.state.servicekey} />
						<Messaging channel={this.state.servicekey} />
						<Emojis channel={this.state.servicekey} />
						<Opening channel={this.state.servicekey} />
						<Handover channel={this.state.servicekey} />
						<Fault channel={this.state.servicekey} />*/}
						<Canvas ref={this.canvas} servicekey={this.state.service.key} servicemode={this.state.service.mode} settings={this.state.settings} />
					</>
				}
				{this.state.service.mode === 5 &&
					<>
						<div className="overlay">
							<Background />
							
							<div className="overlay-welcome1">
								<p>WELCOME</p>
								<div className="overlay-flex">
									<div>
										<img src={`https://cloud.ultrastream.io${this.state.service.avatar}`} width={64} height={64} style={{borderRadius: '50%'}} />
									</div>
									<div style={{paddingTop: 5}}>
										{this.state.service.name}
									</div>
								</div>
							</div>

							<div className="overlay-welcome2">
								<p>SCHEDULE</p>
								{schedule}
							</div>
							
							<div className="overlay-panel">
								<p>TEMPLATES</p>
								{settings}
							</div>
							<div className="overlay-version">
								This screen is just for your own refrence, Version: {process.env.REACT_APP_VERSION}
							</div>
							<div className="overlay-loading">
							</div>
						</div>
					</>
				}
				{process.env.NODE_ENV==="development" &&
					<div style={{position: 'absolute', left: 10, bottom: 10, backgroundColor: '#ffffff', border: '1px solid #777777', padding: '2px 10px', fontWeight: 'bold', color: '#000000', }}>
						Status: {this.state.service.mode}
					</div>
				}
			</>
		);
	}
}

const Overlay = props => {
  const { id } = useParams();
  return <UltrastreamOverlay id={id} {...props} />
}
export default Overlay;


const Background = styled.div`
	background-image: url(https://mix365.co.uk/images/posters/backgrounds/${Math.floor(Math.random()*23+1)}.png);
	background-size: cover;
  background-attachment: fixed;
  width: 100%;
  height: 100%;
  opacity: 0.95;
`